import { render, staticRenderFns } from "./RevistasEmprendedores.vue?vue&type=template&id=6060e580&scoped=true&"
var script = {}
import style0 from "./RevistasEmprendedores.vue?vue&type=style&index=0&id=6060e580&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6060e580",
  null
  
)

export default component.exports